import { PopoverPrimitiveHoverGroupContext } from '#pplx/frontend/aether/primitives/PopoverPrimitive/PopoverPrimitiveHoverGroupContext.js';
import { useCallback, useContext, useEffect, useId, useLayoutEffect, useState } from 'react';
export function usePopoverPrimitiveHoverGroup({ enabled, isOpen, onOpenChange, }) {
    const hoverCardId = useId();
    const hoverCardGroup = useContext(PopoverPrimitiveHoverGroupContext);
    const [isSiblingReplacementClose, setIsSiblingReplacementClose] = useState(false);
    const [shouldSkipOpenAnimation, setShouldSkipOpenAnimation] = useState(false);
    const prepareToOpen = hoverCardGroup?.prepareToOpen;
    const reportOpenState = hoverCardGroup?.reportOpenState;
    const shouldSkipOpenDelay = enabled && hoverCardGroup?.shouldSkipOpenDelay === true;
    const prepareForClose = useCallback(() => setIsSiblingReplacementClose(true), []);
    const requestClose = useCallback(() => {
        prepareForClose();
        onOpenChange(false);
    }, [onOpenChange, prepareForClose]);
    const handleOpenChange = useCallback((nextOpen) => {
        if (enabled && nextOpen) {
            prepareToOpen?.(hoverCardId);
            setIsSiblingReplacementClose(false);
            setShouldSkipOpenAnimation(shouldSkipOpenDelay);
        }
        onOpenChange(nextOpen);
    }, [enabled, hoverCardId, onOpenChange, prepareToOpen, shouldSkipOpenDelay]);
    useLayoutEffect(() => {
        if (!enabled || reportOpenState == null)
            return;
        reportOpenState(hoverCardId, isOpen, requestClose, prepareForClose);
        return () => reportOpenState(hoverCardId, false, requestClose, prepareForClose);
    }, [enabled, hoverCardId, isOpen, prepareForClose, reportOpenState, requestClose]);
    useEffect(() => {
        if (!isSiblingReplacementClose || !isOpen)
            return;
        const resetFrame = window.requestAnimationFrame(() => setIsSiblingReplacementClose(false));
        return () => window.cancelAnimationFrame(resetFrame);
    }, [isOpen, isSiblingReplacementClose]);
    return {
        handleOpenChange,
        isSiblingReplacementClose,
        shouldSkipOpenAnimation,
        shouldSkipOpenDelay,
    };
}
//# sourceMappingURL=usePopoverPrimitiveHoverGroup.js.map